
import * as Colors from '../../colors'
import * as DetailPanel from '../../components/detail-panel'
import * as Form from '../../components/form'
import * as Request from '../../request'

export const FETCH_MEMBER_DETAILS = 'FETCH_MEMBER_DETAILS'
export const UPDATE_MEMBER_DETAILS = 'UPDATE_MEMBER_DETAILS'

export const FETCH_MEMBER = 'FETCH_MEMBER'
export const FETCH_MEMBER_REQUEST = `FETCH_MEMBER_${Request.REQUEST}`
export const FETCH_MEMBER_SUCCESS = `FETCH_MEMBER_${Request.SUCCESS}`
export const FETCH_MEMBER_ERROR = `FETCH_MEMBER_${Request.ERROR}`
export const UPDATE_MEMBER_DETAILS_INLINE = 'UPDATE_MEMBER_DETAILS_INLINE'
export const UPDATE_MEMBER_DETAILS_UPDATE_STATUS = 'UPDATE_MEMBER_DETAILS_UPDATE_STATUS'

export const SERVER_RESOURCE = '/member-details'

export const URL = 'url'

export const PAGE_SIZE = 100
export const MemberFields = {
  Active: 'is_active',
  Created: 'created',
  Email: 'email',
  FirstName: 'first_name',
  ID: 'id',
  LastClick: 'last_click',
  LastName: 'last_name',
  LastNewsbrief: 'last_newsbrief',
  LastOpen: 'last_open',
  Name: 'last_name',
  Subscribed: 'is_subscribed',
  Updated: 'updated',
}

export const SORT_BY = {
  Asc: 'asc',
  Desc: 'desc',
}

export const MemberFilterFormFieldNames = {
  Email: 'email',
  ModifiedSince: 'modifiedSince',
  PartnerCode: 'partner_code',
  ScheduleId: 'schedule_id',
  Status: 'state',
}
export const MEMBERS_FILTER_FORM_INITIAL_VALUES = {
  [MemberFilterFormFieldNames.Email]: '',
  [MemberFilterFormFieldNames.ModifiedSince]: '',
  [MemberFilterFormFieldNames.ScheduleId]: '',
  [MemberFilterFormFieldNames.Status]: 'All',
}

export const colors = [
  Colors.cyan300,
  Colors.cyan400,
  Colors.cyan500,
  Colors.cyan600,
  Colors.grey400,
  Colors.grey500,
  Colors.grey600,
  Colors.grey700,
  Colors.grey800,
  Colors.grey900,
  Colors.red300,
  Colors.red400,
  Colors.red500,
  Colors.red600,
  Colors.red700,
  Colors.yellow300,
  Colors.yellow400,
  Colors.yellow500,
  Colors.green300,
  Colors.green400,
  Colors.green500,
]

export const MEMBER_DETAILS_PREFIX = 'MEMBER_DETAILS'
export const DetailPanelConstants = DetailPanel.createConstantsMap(MEMBER_DETAILS_PREFIX)
export const FormConstants = Form.createConstantsMap(MEMBER_DETAILS_PREFIX)
export const EditFieldActions = Form.createActionsMap(MEMBER_DETAILS_PREFIX)



// WEBPACK FOOTER //
// ./src/pages/member-details/constants.ts